<template>
    <va-row class="center">
        <va-column :md="4">
            <va-card :elevation="2" :padding="10" style="padding: 10px">
                <va-form :class="{dimmed: isLoading}" ref="form"
                    style="display: flex; flex-direction: column; align-items: center; justify-content: space-between; height:290px;">
                    <va-loading v-if="isLoading" size="md" color="white" :center="true" />

                    <img style="width: 82px;" src="@/assets/nepaLogo.png" />
                    <h3 v-if="showForgotPasswordPage">Password reset</h3>
                    <span v-if="!showForgotPasswordPage" style="color: gray; padding: 10px">Login to NEIS</span>
                    <va-input type="email" style="margin-bottom: 10px" icon="user" name="email" v-model="email"
                        placeholder="Your email" :rules="[{type:'required'}]" show-clean />

                    <va-input style="margin-bottom: 10px" v-if="!showForgotPasswordPage" icon="key"
                        @keyup.enter.native="login" name="password" v-model="password" placeholder="Your password"
                        :rules="[{type:'required'}]" type="password" show-clean />
                    <va-button v-if="!showForgotPasswordPage" type="primary" @click.native="login">Login
                    </va-button>
                    <va-button v-if="!showForgotPasswordPage" type="subtle-link"
                        @click.native="() => showForgotPasswordPage = !showForgotPasswordPage">
                        Forgot Password?
                    </va-button>
                    <va-button v-if="showForgotPasswordPage" type="primary" @click.native="sendResetPasswordEmail">
                        Send email
                    </va-button>
                </va-form>
                <va-alert v-if="isError" type="danger" style="text-align: left; justify-content: left">
                    <h4>Error</h4>
                    <p>{{errorMsg}}</p>

                </va-alert>
                <va-button v-if="showForgotPasswordPage" type="subtle-link"
                    @click.native="() => showForgotPasswordPage = false">Login
                </va-button>

            </va-card>
        </va-column>

    </va-row>

</template>
<script>
    import Parse from "@/main.js"
    import {
        mapActions,
        mapGetters
    } from "vuex";
    import UserSelection from "./UserSelection.vue";
    import {
        store
    } from "../store";
    export default {
        components: {
            UserSelection
        },

        data() {
            return {
                type: "horizontal",
                email: "",
                password: "",
                login_background: 'login_background',
                center: 'center',
                showForgotPasswordPage: false,
                fetchedUsers: []
            };
        },
        computed: {
            user() {
                return store.getters.user;
            },
            isLoading() {
                return store.getters.loading;
            },
            errorMsg() {
                return store.getters.error;
            },
            isError() {
                return store.getters.error != null;
            }
        },

        methods: {
            ...mapActions(["signUserIn"]),

            getUsers() {

            },

            async sendResetPasswordEmail() {
                let q = new Parse.Query('User')
                q.equalTo('email', this.email)
                var res = await q.first()
                if (res) {
                    Parse.User.requestPasswordReset(this.email)
                        .then((res) => {
                            this.$notify({
                                group: 'foo',
                                text: this._('An email was sent to your email, please follow the steps to reset your password'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            })
                            this.showForgotPasswordPage = false
                        }).catch((error) => {
                            this.$notify({
                                group: 'foo',
                                text: this._('An error accured while sending email'),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            })
                            this.showForgotPasswordPage = false
                        });
                } else {
                    this.$notify({
                        group: 'foo',
                        text: this._('No user was found'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    })
                    this.showForgotPasswordPage = false
                }

            },

            login() {
                this.$refs.form.validateFields(result => {
                    if (result.isvalid) {
                        this.signUserIn({
                            email: this.email,
                            password: this.password
                        });
                    }
                });
            }
        }
    };
</script>

<style>
    .center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        min-height: 100vh;
        min-width: 200px;
    }
</style>